import { ApiError } from '../client';
import { PERMISSION_REFUSAL_CODES, type PermissionRefusal } from '../schemas/permissionRefusal';

// Which mocked calls answer a Rechazo por permiso. Module state, like every other mock store here;
// armed from tests and from the shell's dev-only control.
let armed: ReadonlySet<string> | 'all' | null = null;

export function setPermissionRefusalMock(calls: readonly string[] | 'all' | null): void {
  armed = calls === null || calls === 'all' ? calls : new Set(calls);
}

export function resetPermissionRefusalMock(): void {
  armed = null;
}

const [SHARED_CODE] = PERMISSION_REFUSAL_CODES;
const SHARED_MESSAGE = 'The panel permission required for this request is missing.';

// Thrown the way the server answers: the shared code with the delivered message and the refused
// permission in `detail`; the access-management code as delivered, with no `detail`. The panel never
// reads `detail`: it is here so the mock matches the wire. The caller names the
// permission and the code its route answers because this package does not know the catalog.
export function refusePermissionIfInjected(
  call: string,
  permission: string,
  code: PermissionRefusal['code'],
): void {
  if (armed === null || (armed !== 'all' && !armed.has(call))) return;
  const body =
    code === SHARED_CODE
      ? { code, message: SHARED_MESSAGE, detail: { permission } }
      : { code, message: 'Access management required.' };
  throw new ApiError(403, code, body, `${call} failed: ${code}`);
}
